// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1B_dO","type":"styles_type__2uz06","choices":"styles_choices__217xT"};